// extracted by mini-css-extract-plugin
module.exports = {"root":"AppNotification-root-27hpF","inner":"AppNotification-inner-1aT-U","success":"AppNotification-success-esuaa"};